import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sessionsApi } from '../../../api/sessionsApi';
import { DEFAULT_PROVIDER } from '../../../constants/transcriptProviders';
import { DEFAULT_TRANSCRIPTION_LANGUAGE } from '../../../constants/transcriptionLanguages';
import { buildSessionPayload } from '../utils/buildSessionPayload';

const EMPTY_LINK = { eventId: '', sessionId: '', eventTitle: '', sessionTitle: '' };

/** Session fields of the upload form (link, title, transcription) and creating the session. */
export function useCreateSessionForm(uploadId, notifyError) {
  const navigate = useNavigate();
  const [source, setSource] = useState('WordPress');
  const [link, setLink] = useState(EMPTY_LINK);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [transcribe, setTranscribe] = useState(true);
  const [provider, setProvider] = useState(DEFAULT_PROVIDER);
  const [language, setLanguage] = useState(DEFAULT_TRANSCRIPTION_LANGUAGE);
  const [submitting, setSubmitting] = useState(false);

  const changeSource = (next) => {
    setSource(next);
    setLink(EMPTY_LINK);
  };

  const changeLink = (selection) => {
    // Fill the title from the picked session unless the user already typed their own.
    if (selection.sessionTitle && (!title || title === link.sessionTitle)) {
      setTitle(selection.sessionTitle);
    }
    setLink({ ...EMPTY_LINK, ...selection });
  };

  const canSubmit = Boolean(uploadId && title.trim()) && !submitting;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      const session = await sessionsApi.create(buildSessionPayload({
        uploadId, title: title.trim(), description, source, link, transcribe, provider, language,
      }));
      navigate(session?.id ? `/sessions/${session.id}` : '/sessions');
    } catch (error) {
      notifyError('Could not create session', error.message);
      setSubmitting(false);
    }
  };

  return {
    source, changeSource, changeLink,
    title, setTitle, description, setDescription,
    transcribe, setTranscribe, provider, setProvider, language, setLanguage,
    submitting, canSubmit, submit,
  };
}
